(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/play.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/play.js');
"use strict";

const _React = React,
  useContext = _React.useContext;
const _ReactRouterDOM = ReactRouterDOM,
  Route = _ReactRouterDOM.Route,
  Switch = _ReactRouterDOM.Switch;
const ResetToSystem = svs.components.tipsen.routePlaySpela.ResetToSystem;
const SystemSelector = svs.components.tipsen.routePlaySpela.systemSelector.SystemSelector;
const CouponChoice = svs.components.tipsen.routePlaySpela.couponChoice.CouponChoice;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const Coupon = svs.components.tipsen.coupon.Coupon;
const _svs$components$tipse = svs.components.tipsen.couponId,
  useCouponId = _svs$components$tipse.useCouponId,
  PaymentContext = _svs$components$tipse.PaymentContext;
const useActionListener = svs.components.tipsen.hooks.useActionListener;
const useComponentFromRegistry = svs.components.tipsen.componentRegistry.useComponentFromRegistry;
const RenderProvider = svs.component.tipsen.renderContext.RenderProvider;
const pageTypes = svs.component.tipsen.renderContext.constants.pageTypes;
const Play = _ref => {
  let match = _ref.match;
  const couponId = useCouponId();
  const placeBetAsync = useContext(PaymentContext);
  useActionListener({
    couponId,
    placeBetAsync
  });
  const CouponComponent = useComponentFromRegistry('coupon', React.createElement(Coupon, null));
  return React.createElement(React.Fragment, null, React.createElement(Switch, null, React.createElement(Route, {
    component: SystemSelector,
    path: "".concat(match.path).concat(TipsenModuleGameUrl.SYSTEM)
  }), React.createElement(Route, {
    component: ResetToSystem
  })), React.createElement(RenderProvider, {
    pageType: pageTypes.DEFAULT
  }, React.createElement(CouponChoice, null), React.createElement(CouponComponent, null)));
};
setGlobal('svs.components.tipsen.routePlaySpela.Play', Play);

 })(window);